import _styled, { css as _css } from "styled-components";
import LogoMark from "~/public/logo/logo-mark.svg";
import LogoFull from "~/public/logo/logo-full.svg";
import LogoText from "~/public/logo/logo-text.svg";
type Props = {
  logo: keyof typeof logos;
  variant: keyof typeof variants;
};
const logos = {
  mark: LogoMark,
  full: LogoFull,
  text: LogoText
} as const;
const variants = {
  light: {
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  },
  dark: {
    "--tw-text-opacity": "1",
    "color": "rgb(0 7 4 / var(--tw-text-opacity))"
  }
} as const;
export function Logo(props: Props & React.ComponentPropsWithoutRef<"div">) {
  const {
    logo,
    variant,
    ...rest
  } = props;
  const Component = logos[logo];
  if (!Component) {
    return null;
  }
  return <_StyledDiv {...rest} $_css2={[variants[variant], {
    "transitionProperty": "opacity",
    "transitionDuration": "250ms",
    "transitionTimingFunction": "ease-in-out",
    "@media (hover: hover)": {
      "&:hover": {
        "opacity": "0.8"
      }
    }
  }, _css(["> svg{", "}"], {
    "height": "auto",
    "width": "100%"
  })]}>
      <Component />
    </_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "logo___StyledDiv",
  componentId: "sc-2fa1we-0"
})(["", ""], p => p.$_css2);